// extracted by mini-css-extract-plugin
export default {"host":"Tooltip_host__3Z6mq","tip":"Tooltip_tip__IR1x5","tipRight":"Tooltip_tipRight__OFE1l"};